// extracted by mini-css-extract-plugin
export default {"main":"gMU15","title":"bE1Ka","questionContainer":"vqaOc","question":"wEHTQ","answer":"IXznC"};